
import { computed, defineComponent, ref } from 'vue'
import { useResizableTextarea } from '../../../composables/use-resizable-textarea'
import { EpbTextbox } from '../epb-textbox'

export default defineComponent({
  name: 'EpbTextarea',
  components: {
    EpbTextbox,
  },
  props: {
    ...EpbTextbox.props,
    value: {
      type: String,
      default: '',
    },
  },
  emits: {
    input: (value: string) => {},
    change: (value: string) => {},
    keydown: (value: Event) => {},
  },
  setup(props) {
    const inputRef = ref<HTMLTextAreaElement>()

    const INPUT_MIN_HEIGHT_PX = 64
    const INPUT_MARGIN_FOR_SCROLL_PX = 2

    const { resizeTextarea } = useResizableTextarea(
      inputRef,
      computed(() => props.value),
      {
        minHeight: INPUT_MIN_HEIGHT_PX,
        scrollMargin: INPUT_MARGIN_FOR_SCROLL_PX,
      },
    )

    return {
      baseClass: 'epb-textarea',
      inputRef,
    }
  },
})
